"use client"

import { Great_Vibes } from "next/font/google"

const signatureFont = Great_Vibes({
    subsets: ["latin"],
    weight: ["400"],
})

const ChairmanMessageSection = () => {
    return (

        <section className="py-10 xl:py-12 2xl:py-16 min-[1920px]:py-24 bg-white dark:bg-white transition-colors duration-500">
            <div className="max-w-[94%] mx-auto px-4">


                <div className="grid grid-cols-1 xl:grid-cols-[45%_55%] rounded-3xl overflow-hidden min-h-[300px] xl:min-h-[380px] 2xl:min-h-[500px] min-[1920px]:min-h-[700px]">


                    <div className="relative h-64 xl:h-full w-full">
                        <img
                            src="/images/THUTQG.png"
                            alt="Chủ tịch Hội đồng Quản trị Rovi Holdings"
                            className="w-full h-full object-cover object-center xl:object-[80%_top]"
                        />
                    </div>


                    <div className="relative h-full bg-black">

                        <div className="absolute inset-0 bg-black/40"></div>

                        <video className="absolute inset-0 w-full h-full object-cover" autoPlay muted loop playsInline>
                            <source src="/videos/bg-chutichtieng.mp4" type="video/mp4" />
                        </video>


                        <div className="relative z-10 flex flex-col justify-center items-start h-full px-6 py-8 xl:px-16 xl:py-10 2xl:px-20 2xl:py-14 min-[1920px]:px-32 min-[1920px]:py-20 text-left text-white">


                            <div className="mb-0 mt-2 xl:mt-4 2xl:mt-6 -ml-1 xl:-ml-2 2xl:-ml-3 min-[1920px]:-ml-4">
                                <p

                                    className="text-7xl xl:text-9xl 2xl:text-[10rem] min-[1920px]:text-[14rem] leading-none text-white font-bold opacity-80"
                                    style={{
                                        fontFamily: "'Helvetica Neue', Arial, sans-serif",
                                    }}
                                >
                                    “
                                </p>
                            </div>

                            {/* Đoạn trích dẫn */}
                            <p

                                className="text-xs xl:text-sm 2xl:text-base min-[1920px]:text-xl leading-relaxed mb-4 xl:mb-6 2xl:mb-8 min-[1920px]:mb-12 tracking-wide text-white max-w-2xl 2xl:max-w-3xl min-[1920px]:max-w-5xl -mt-4 xl:-mt-8 2xl:-mt-10 min-[1920px]:-mt-16 relative"
                                style={{
                                    fontFamily: "'Helvetica Neue', Arial, sans-serif",
                                    fontWeight: 300,
                                }}
                            >
                                Trong từng hành trình, Rovi Holdings luôn thể hiện sự dấn thân, kết nối, sức mạnh đoàn kết vững mạnh và
                                không ngừng tiến về phía trước để mang đến cho Quý nhà đầu tư, Quý khách hàng cùng Quý đối tác những sản
                                phẩm, dịch vụ và lợi ích tuyệt vời, trọn vẹn nhất. Sự nỗ lực không ngừng nghỉ của tập thể và sự phát
                                triển bền vững của Rovi Holdings đã giúp tập đoàn ngày càng khẳng định vị thế, góp phần nâng cao chất
                                lượng thương hiệu Việt vươn tầm quốc tế.
                            </p>

                            {/* Tên và chức danh */}
                            <div className="mt-auto">
                                <p

                                    className={`${signatureFont.className} text-2xl xl:text-3xl 2xl:text-4xl min-[1920px]:text-6xl text-white origin-left transform -rotate-6`}
                                >
                                    Chị Kim Tiếng
                                </p>
                                <p

                                    className="text-[10px] xl:text-xs 2xl:text-sm min-[1920px]:text-lg mt-2 2xl:mt-3 min-[1920px]:mt-4 font-light tracking-widest uppercase text-white"
                                    style={{
                                        fontFamily: "'Helvetica Neue', Arial, sans-serif",
                                    }}
                                >
                                    Chủ tịch HĐQT kiêm TGĐ Rovi Holdings
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default ChairmanMessageSection